export const webTemplateConstants = {
    WEB_TEMPLATE_LIST_PENDING: 'WEB_TEMPLATE_LIST_PENDING',
    WEB_TEMPLATE_LIST_FULFILLED: 'WEB_TEMPLATE_LIST_FULFILLED',
    WEB_TEMPLATE_LIST_REJECTED: 'WEB_TEMPLATE_LIST_REJECTED',
    WEB_TEMPLATE_UPDATE_PENDING: 'WEB_TEMPLATE_UPDATE_PENDING',
    WEB_TEMPLATE_UPDATE_FULFILLED: 'WEB_TEMPLATE_UPDATE_FULFILLED',
    WEB_TEMPLATE_UPDATE_REJECTED: 'WEB_TEMPLATE_UPDATE_REJECTED',
    WEB_TEMPLATE_CLEAR: 'WEB_TEMPLATE_CLEAR',
};
